// NAVIGATION & REMOVE PRELOAD *****************************************      
$(window).on("load", function() {                                                                                                                  
   


   // remove pre-load ***
   // setTimeout(function() { $("body").removeClass("preload"); }, 200);



   // initialization *********
   var i = 0,
       megaMenuOpen = false,
       done = true; 
   
    

   // mega menu open *********
   $("#ProductsHover").hover(function() { 

   	  if (!($(this).hasClass("hovered"))) {

   	  	 $(this).addClass("hovered");
   	  	 megaMenuOpen = true;

         $("#Navigation #MegaMenu").addClass("active"); 

         for (let n = 1; n < 5; n++)	{
            setTimeout(function() { 
               $("#Navigation #MegaMenu").children("a").eq(n - 1).find(".mmcol").addClass("active");
            }, 100 * n);
         }

      }

   });



   // mega menu close *********
   $("#ProductsHover, #Navigation #MegaMenu").on("mouseleave", function(e) {

   	    if (megaMenuOpen) {

   	       var elOnLeave = e.toElement.getAttribute("class"); 

   	       if (!(elOnLeave === "mmhe" || elOnLeave === "mmhe active" || elOnLeave === "hovered")) { 

   	       	  megaMenuOpen = false; 
              $("#Navigation #MegaMenu").removeClass("active");  
              $("#Navigation #MegaMenu .mmcol").removeClass("active");
   	    	  $("#ProductsHover").removeClass("hovered");  

   	       }

   	    }
   	    
   });



   // animation handler *********
   $("#Hamburger").click(function() {
	   
	  if (done) { 

		 doneUtil();

		 i++;
	     
		 (i % 2 !== 0) ? navOpen() : navClose(); 
	  
	  } 
	  
   }); 
   
   

   // open function *********
   function navOpen() { 
	  $("#Hamburger").addClass("active");  	      
	  setTimeout(function() {     
         $("#MobileNavigation, #MobileNavigationOverlay").css({"display":"block"}).animate({ opacity: 1 }, 500);
		 $("#MobileNavigation #Social").addClass("active");   	 
      }, 750);   
   }
    
      

   // close function *********
   function navClose() {   
	  $("#MobileNavigation, #MobileNavigationOverlay").animate({ opacity: 0 }, 500, function() { $(this).css({"display":"none"}); });
	  $("#MobileNavigation #Social").removeClass("active");
	  setTimeout(function() {  
	     $("#Hamburger").removeClass("active");    
      }, 250); 
   }  
   
   

   // done util ********* 
   function doneUtil(increment) { 
      done = false;
	  setTimeout(function() { done = true; }, 1000);  	  
   }  
   

   
   // resize *********
   $(window).on("resize", function() {
	   
	  if ($("#Navigation").css("display") === "block") { 
         $("#MobileNav, #Hamburger, #MobileNavigation, #MobileNavigationOverlay").removeClass("active").css({"display":"none"});	
	  } 
	   
   }); 
   
   

}); 








// CART FUNCTIONALITY ******************************** 
// $(window).on("load", function() {                             





    // init *** 
    var doneUtil = [ { done: true }, { done: true }, { done: true }, { done: true } ], 
        addToCart = false, 
        firstAddToCart = true,  
        totalCartItems = 0,  
        totalPrice = 0,
        setTotalCartItemsAgain = true;





    // set total cart items ***
	setTotalCartItems();  





    // open cart ***   
    $("#CartButton, #MobileCartButton").click(function() {   

        if (doneUtil[0].done) { 

           doneUtilFunc(0, 1000); 

           if (setTotalCartItemsAgain) { setTotalCartItemsAgain = false; setTotalCartItems(); } // set total cart items again as per cache bug  

           let openCartDelay = 250;        
    	   if (!addToCart && !(totalCartItems === 0)) { fetchCartData(50); openCartDelay = 400; }        

           openCartSuccess(openCartDelay);      

    	}

    });  


    // open cart success ***
    function openCartSuccess(delayTimer) {

	   setTimeout(function() {    

	      $("#CartSection").css({"display":"block"}); 

	      setTimeout(function() { 

	          addToCart = false; 
	      	  if (!firstAddToCart) { firstAddToCart = true; } 
    	      
    	      $("#CartSection").addClass("active"); 
    	      $("#CartSection #Cart").addClass("active");   

	      }, 50);              

	   }, delayTimer);        

    }





    // close cart *** 
    $("#CartClose").click(function() { 

        if (doneUtil[0].done) { 

           doneUtilFunc(0, 1000);  

    	   $("#CartSection #Cart").removeClass("active"); 
    	   setTimeout(function() { $("#CartSection").removeClass("active"); }, 300); 
    	   setTimeout(function() { $("#CartSection").css({"display":"none"}); }, 800);  

    	} 

    });  





    // add to cart & buy now buttons ***           
    $("#FeaturedSection #FeaturedAdd, #FeaturedSection #BuyNow").click(function() {    
     
        if (doneUtil[1].done && firstAddToCart) { 

           doneUtilFunc(1, 1000);      

           if (setTotalCartItemsAgain) { setTotalCartItemsAgain = false; setTotalCartItems(); } // set total cart items again as per cache bug  

    	   addToCart = true;  

           var variant = $("#FeaturedSection #FeaturedContent .btns.two h5.active").attr("data-variantid"),
               qty = Number($("#FeaturedSection #FeaturedQuantity span.qty").text()),
               items = [{ quantity: qty, id: variant }],
               buyNow = false;     

           if ($(this).hasClass("bn")) { buyNow = true; } 

 	       $.ajax({
	          type: "POST",
		      url: '/cart/add',
			  data: { items: items }, 
			  success: fetchCartData(250, qty, buyNow),       
			  dataType: 'application/json'
		   });

		}

    });




 
	// fetch cart data ***      
    function fetchCartData(timeoutDelay, nQty, bn) {       
        
	    setTimeout(function() { 

	    	if (bn) {

	    	   setTimeout(function() { window.location.href = "/cart/checkout"; }, 500);                  

	    	}
	    	else {

		       fetch(window.Shopify.routes.root + 'cart.js') 
		       .then(response => response.json()) 
		       .then(data => {  

		       	  console.log(data.item_count);      

                  if (addToCart && firstAddToCart) { firstAddToCart = false; totalCartItems += nQty; }          

                  if (data.item_count === 0 || data.item_count < totalCartItems) { 
                     console.log("CART ADD FAILED TO REGISTER, RUNNING FETCH AGAIN");     
                     fetchCartData(250);      
                  }
                  else {   
		    	     useCartData(data);   
		    	  }

		    	  console.log(totalCartItems);    

		       });      

		    }

	    }, timeoutDelay);     

    }


    // display fetched cart data ***
    function useCartData(data) {   

    	$("#Cart #CartItems").html(" "); 
    	totalPrice = 0;  

    	for (let i = 0; i < data.items.length; i++) {

    		var priceRaw = String(data.items[i].price),
    		    priceRawLength = priceRaw.length, 
    		    realPrice = Number(priceRaw.slice(0, priceRawLength - 2) + "." + priceRaw.slice(priceRawLength - 2, priceRawLength));    

	    	$("#Cart #CartItems").append(  
	    		"<div class='cartitem " + data.items[i].id + "'>" +
	    		   "<img class='citemcol img' src='" + data.items[i].image + "'>" +
	    		   "<div class='citemcol header'>" +
	    		      "<h2>" + data.items[i].title + "</h2>" +
	    		      "<p> $" + realPrice + "<span>#" + data.items[i].id + "</span> </p>" +
	    		   "</div>" +
	    		   "<div class='citemcol adjust'>" +
	    		      "<h5 data-adjustid='" + data.items[i].id + "' data-adjustprice='" + realPrice + "'> <span class='minus mp'>-</span> <span class='qty'>" + data.items[i].quantity + "</span> <span class='plus mp'>+</span> </h5>" +
	    		      "<a class='removecartitem' data-removalid='" + data.items[i].id + "' data-removalprice='" + realPrice + "' data-removalkey='" + data.items[i].key + "'>REMOVE</a>" +
	    		   "</div>" +  
	    		"</div>"
	        );    

            totalPrice += (realPrice * data.items[i].quantity);

    	}

    	$("#CartFooter p span").text("$" + totalPrice.toFixed(2));

    	if (addToCart) { $("#CartButton").click(); }  

    }





    // adjust cart qty ***  
    $(document).on('click', '.citemcol.adjust h5 span.mp', function() { 

        if (doneUtil[2].done) { 

           doneUtilFunc(2, 300);       

           let nThis = $(this),
    	       type = nThis.attr("class"),    
               thisPrice = Number(nThis.parent().attr("data-adjustprice")),
               thisQty = Number(nThis.parent().find(".qty").text());    

    	   if (type === "minus mp" && thisQty > 1) {      
    	      thisQty--; 
              totalPrice -= thisPrice; 
    	   }

    	   if (type === "plus mp") { 
    		  thisQty++;
              totalPrice += thisPrice; 
     	   }

 	       $.ajax({
	          type: "POST",
		      url: '/cart/change.js',
			  data: { id: nThis.parent().attr("data-adjustid"), quantity: thisQty },  
			  success: newCartQtySuccess(nThis, thisQty, type),   
			  dataType: 'application/json' 
		   });   

        }  

    });


    // adjust cart qty success ***  
    function newCartQtySuccess(el, qty, changeType) { 

        el.parent().find(".qty").text(qty);
        $("#CartFooter p span").text("$" + totalPrice.toFixed(2)); 
        (changeType === "minus mp") ? totalCartItems-- : totalCartItems++;  

	} 





    // remove cart item ***   
    $(document).on('click', '.citemcol.adjust .removecartitem', function() { 

        if (doneUtil[3].done) { 

            doneUtilFunc(3, 1000);   

            let nThis = $(this),
                thisParentId = nThis.attr("data-removalid"),
                thisRemovalPrice = nThis.attr("data-removalprice"), 
                thisRemovalKey = nThis.attr("data-removalkey");   

    		$.ajax({
    			type: 'GET', 
    			url: "/cart/change?id=" + thisRemovalKey + "&quantity=0",                  
    			dataType: 'html',   
    			error: function(xhr) { removeItem(nThis, thisParentId, thisRemovalPrice); },  
    			success: function(response) { removeItem(nThis, thisParentId, thisRemovalPrice); }
    		}); 

        }

	}); 


    // remove item success *** 
    function removeItem(el, id, price) {    
       
       let qtyToRemove = Number(el.parent().find(".qty").text());

       totalPrice -= Number(price) * qtyToRemove;   
       $("#CartFooter p span").text("$" + totalPrice.toFixed(2));

       totalCartItems -= qtyToRemove; 
       $("#Cart #CartItems .cartitem." + id).remove();        

    }





    // set total cart items *** 
    function setTotalCartItems() {
	   fetch(window.Shopify.routes.root + 'cart.js')  
	   .then(response => response.json())  
	   .then(data => { totalCartItems = data.item_count; });        
    }




    // done util *** 
    function doneUtilFunc(pos, delay) { 
	   doneUtil[pos].done = false;
	   setTimeout(function() {
	      doneUtil[pos].done = true;
	   }, delay);
    } 





// });








// ANIMATION ELEMENT ********************************
/*
$(window).on("load", function() {     


   // remove parallax of mission image in mobile ***   
   $(window).on("resize", function() {

      if ($("#MissionSection .col").css("float") === "none") {
      	
         $("#MissionSection .col.image .img").removeClass("parallax-element").css({"height":"100%","position":"relative","transform":"translate(0px,0px)"});

      }  

   }).resize(); 
   
   	    
   // scroll listener ********* 
   $(window).on("scroll", function() {   
		  
	  $(".animation-element, .parallax-element").each(function() {
		  
	     var elem = $(this), 
             windowTop = $(window).scrollTop(), 
             windowBottom = (windowTop + $(window).height()), 
             elementTop = elem.offset().top, 
             elementBottom = (elementTop + elem.height());   
		  
         if (( elementBottom >= windowTop ) && ( elementTop <= windowBottom )) {
	        
			// ae
			if (elem.hasClass("animation-element")) {
			   
			   var num = elem.attr("data-num"); 
			    
			   // general
		       $(".animation" + num).addClass("in-view");     
			   
			} 
			
			// parallax       
			if (elem.hasClass("parallax-element")) { 
		       
			   var scrollDistance = windowBottom - elementTop,
		           percent = scrollDistance / ($(window).height() + elem.height());
			   
			   if (elem.hasClass("welcome-parallax")) { 
			      scrollDistance = windowTop; 
		          percent = scrollDistance / $("#WelcomeSection").height();    
			   } 
			   
			   var distance = percent * elem.attr("data-distance"),
				   opacityShow = percent * 2.5,
                   opacityHide = (1 - (percent/elem.attr("data-opacityRate"))),
                   scaleRate = (1 - (percent/elem.attr("data-scaleRate"))), 				   
                   rotate = 360 * percent;    
			   
			   if ((elem.hasClass("down"))) { elem.css({"transform": "translate(0px," + distance + "px)" }); }  
			   if ((elem.hasClass("up"))) { elem.css({"transform": "translate(0px," + (-distance) + "px)" }); } 
			   if ((elem.hasClass("right"))) { elem.css({"transform": "translate(" + distance + "px, 0px" }); }  
			   if ((elem.hasClass("left"))) { elem.css({"transform": "translate(" + (-distance) + "px, 0px" }); } 			   
			   if ((elem.hasClass("opacityShow"))) { elem.css({"opacity": opacityShow }); }  				  
			   if ((elem.hasClass("opacityHide"))) { elem.css({"opacity": opacityHide }); } 
			   if ((elem.hasClass("rotate"))) { elem.css({"transform": "rotate(" + rotate + "deg)" }); } 
			   if ((elem.hasClass("scale"))) { elem.css({"transform": "scale(" + scaleRate + ")" }); } 
			   if ((elem.hasClass("width"))) { elem.css({"width": distance }); } 
			   if ((elem.hasClass("height"))) { elem.css({"height": distance }); }   
			      
			}
		    
	     }
         
	  });
	  
   }).scroll();
      
   
}); 
*/







